import { render, staticRenderFns } from "./new-partner.pug?vue&type=template&id=1f543084&lang=pug&"
import script from "./new-partner.ts?vue&type=script&lang=ts&"
export * from "./new-partner.ts?vue&type=script&lang=ts&"
import style0 from "./new-partner.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports